export enum SituacaoPendenciaFechamentoCaixa {
  CONFIRMACAO_PENDENTE = 'CONFIRMACAO_PENDENTE',
  CONFIRMADA = 'CONFIRMADA',
}
